import api, { methods } from "@api";

import type { AssistantChatMessage, AssistantChatResponse } from "./assistant-types";

export function sendAssistantRecipeChat({
  messages,
  currentPath,
}: {
  messages: AssistantChatMessage[];
  currentPath?: string;
}) {
  return api<AssistantChatResponse>({
    path: "/assistant/recipe-chat",
    method: methods.POST,
    body: {
      messages,
      current_path: currentPath || "",
    },
  });
}
